import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { compose } from 'redux';

import { PageTitle } from '../../Text';
import HomeButton from '../HomeButton';
import { Button } from '../../Button';

import {
  withApiActions,
  withCancelForm,
  withScreenActions,
} from '../../../hocs/withActions';

const SignatureMessage = ({
  RemoveSignatureStatus = {},
  CancelForm = () => {},
  DisableSpinner = () => {},
}) => {
  const initialStatus = 200;
  const handleOnPress = () => {
    DisableSpinner();
    RemoveSignatureStatus(initialStatus);
    CancelForm();
  };
  return (
    <div className="modal">
      <div className="error-content">
        <PageTitle>Error sending the form</PageTitle>
        <p>
          <span>Please check that you have entered the correct data</span>
        </p>
        <Button classButton="back" onPress={handleOnPress}>
          <RouterLink to="/declaration">Back to declaration</RouterLink>
        </Button>
        <p>
          <span>There is a problem with the website. Please start again.</span>
        </p>
        <HomeButton />
      </div>
    </div>
  );
};

export default compose(
  withApiActions,
  withCancelForm,
  withScreenActions
)(SignatureMessage);
